export function getUserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function formatToUTC(date: Date | string | null | undefined): string | undefined {
  if (!date) return undefined;

  const d = new Date(date);
  const year = d.getUTCFullYear();
  const month = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  const hours = String(d.getUTCHours()).padStart(2, '0');
  const minutes = String(d.getUTCMinutes()).padStart(2, '0');
  const seconds = String(d.getUTCSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function parseUTCToLocal(utcDateTimeStr: string | null | undefined): Date | null {
  if (!utcDateTimeStr) return null;
  return new Date(utcDateTimeStr.replace(' ', 'T') + 'Z');
}
